import { createGlobalStyle } from 'styled-components';

export const OcGlobalStyleWrapper = createGlobalStyle`
  /* Widget root */
  .hl-oc-chat-content {
    font-family: Inter, "Helvetica Neue", Arial, sans-serif;
  }

  .hl-oc-chat-content * {
    font-family: inherit;
  }

  /* Element-specific resets */
  .hl-oc-chat-content code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  .hl-oc-chat-content :where(button) {
    font-family: inherit;
  }
  
  .hl-oc-chat-content :where(button):focus:not(:focus-visible) {
    outline: none;
  }

  .hl-oc-chat-content a {
    text-decoration: none;
  }
`;
